import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const MetricContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: theme.spacing(1),
}));

const MetricValue = styled(Typography)(({ theme }) => ({
  fontSize: '1.5rem',
  fontWeight: 700,
  color: '#1A202C',
  marginBottom: theme.spacing(0.5),
}));

const MetricLabel = styled(Typography)(({ theme }) => ({
  fontSize: '0.875rem',
  color: '#718096',
  textAlign: 'center',
}));

const RealTimeMetrics: React.FC = () => {
  const metrics = [
    { value: '1,250', label: 'Users' },
    { value: '3,600', label: 'Units' },
    { value: '3', label: 'Pending Cancel' },
    { value: '450', label: 'API Calls' },
    { value: '$8.3M', label: 'Monthly Revenue' },
    { value: '$100M', label: 'Annual Revenue' },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, color: '#1A202C', mb: 2 }}>
        Real-time Metrics
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 1 }}>
        {metrics.map((metric, index) => (
          <MetricContainer key={index}>
            <MetricValue>{metric.value}</MetricValue>
            <MetricLabel>{metric.label}</MetricLabel>
          </MetricContainer>
        ))}
      </Box>
    </Box>
  );
};

export default RealTimeMetrics; 